import React, {useState} from 'react';
import {Heading} from "@/components/ui/heading";
import SwitchComponent from "@/components/switchComponent";
import SubscriptionBox from "./components/SubscriptionBox";
import Paths from "../../constants/Paths";

const subscriptions = [
    {
        title: 'Basic',
        textFeatures: 'BASIC plan includes:',
        features: [
            {text: 'AI-Powered Assistant.', included: true},
            {text: 'The ability to generate 10 analyses with a single click.', included: true},
            {text: 'Lifetime access to our Discord community.', included: true},
            {text: 'Instant access to educational materials.', included: true},
            {text: 'Participation in regularly organized webinars with experts.', included: true},
            {text: 'Possibility to purchase additional analyses - $5 per package of 10 analyses.', included: true},
        ],
        costWeekly: '$9.99',
        buttonText: 'Subscribe',
        isHighlighted: false,
        bottomText: 'Best to test',
        monthlyCosts: {
            costWeekly: '$9.99',
            costWeeklyWithoutDiscount: '$14.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: Paths.LT_SUB_BASIC
        },
        yearlyCosts: {
            costWeekly: '$9.99',
            costWeeklyWithoutDiscount: '$14.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: Paths.LT_SUB_BASIC
        },
        onlyMonthly: true,
    },
    {
        title: 'Expert',
        textFeatures: 'EXPERT plan includes:',
        features: [
            {text: 'AI-Powered Assistant.', included: true},
            {text: 'The ability to generate 150 analyses.', included: true},
            {text: 'Lifetime access to our Discord community.', included: true},
            {text: 'Instant access to educational materials.', included: true},
            {text: 'Participation in regularly organized webinars with experts.', included: true},
            {text: 'Access to live trading sessions where you’ll learn professional strategies used by our team.', included: true},
            {text: 'Possibility to purchase additional analyses - $25 per package of 100 analyses.', included: true},
        ],
        costMonthly: '$49.99',
        costYearlyWithDiscount: '$527.89',
        costYearlyWithoutDiscount: '$599.88',
        buttonText: 'Subscribe',
        isHighlighted: true,
        bottomText: 'Best price per one analyses',
        monthlyCosts: {
            costMonthly: '$49.99',
            costMonthlyWithoutDiscount: '$74.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: Paths.LT_SUB_EXPERT_MONTHLY
        },
        yearlyCosts: {
            costYearly: '$527.89',
            costYearlyWithoutDiscount: '$899.88',
            discountPercent: '-41%',
            isDiscount: true,
            url: Paths.LT_SUB_EXPERT_YEARLY
        },
        onlyMonthly: false,
    },
    {
        title: 'Pro',
        textFeatures: 'PRO plan includes:',
        features: [
            {text: 'AI-Powered Assistant.', included: true},
            {text: 'The ability to generate 50 analyses.', included: true},
            {text: 'Lifetime access to our Discord community.', included: true},
            {text: 'Instant access to educational materials.', included: true},
            {text: 'Participation in regularly organized webinars with experts.', included: true},
            {text: 'Access to live trading sessions where you’ll learn professional strategies used by our team.', included: true},
            {text: 'Possibility to purchase additional analyses - $15 per package of 50 analyses.', included: true},
        ],
        costMonthly: '$29.99',
        costYearlyWithDiscount: '$316.69',
        costYearlyWithoutDiscount: '$359.88',
        buttonText: 'Subscribe',
        isHighlighted: false,
        bottomText: 'Most popular',
        monthlyCosts: {
            costMonthly: '$29.99',
            costMonthlyWithoutDiscount: '$44.99',
            discountPercent: '-33%',
            isDiscount: true,
            url: Paths.LT_SUB_PRO_MONTHLY
        },
        yearlyCosts: {
            costYearly: '$316.69',
            costYearlyWithoutDiscount: '$539.88',
            discountPercent: '-41%',
            isDiscount: true,
            url: Paths.LT_SUB_PRO_YEARLY
        },
        onlyMonthly: false,
    },
];


const SectionSubscriptions = () => {
    const [isMonthly, setIsMonthly] = useState(true);

    const handleIsMonthly = () => {
        setIsMonthly(!isMonthly);
    };

    return (
        <section className="section-subscriptions pt-14 pb-7">
            <div className="generic-container">
                <Heading level={2}>Choose your plan</Heading>
                <Heading level={3}>Pay yearly and get a discount!</Heading>
                <SwitchComponent isMonthly={isMonthly} handleIsMonthly={handleIsMonthly}/>
                <div
                    className={`subscription-boxes-container`}>
                    {subscriptions.map((sub, index) => (
                        <SubscriptionBox key={index} {...sub} isMonthly={isMonthly}/>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SectionSubscriptions